"use client";

import { ListingFavoriteButton } from "@/components/listings/listing-favorite-button";
import type { DetailedListing } from "@/lib/types";
import { useTranslations } from "next-intl";

export function SaveListingButton({
  listing,
  invert,
}: { listing: DetailedListing; invert?: boolean }) {
  const t = useTranslations();

  return (
    <ListingFavoriteButton
      variant="button"
      listingId={listing.id}
      favoriteLabel={t("saas.listing.header.actions.save")}
      unfavoriteLabel={t("saas.listing.header.actions.saved")}
      invert={invert}
    />
  );
}

SaveListingButton.displayName = "SaveListingButton";
